import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { formatPlural } from 'utils';
import useColors from 'hooks/useColors';
import { useMainStackNavigation, useMainStackRoute } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
const FundThemeCategorizationCard = ({ style, fundInfo }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const route = useMainStackRoute();
    const onPress = React.useCallback((title) => () => {
        navigation.navigateDeprecated('InvestDiscoverCategorizationDetails', {
            type: 'theme',
            initialSelected: title,
            depositAndBuyFlowParams: route.params?.depositAndBuyFlowParams,
        });
    }, [route.params?.depositAndBuyFlowParams]);
    return (<View style={[styles.cardWrapper, style]}>
      <TouchableBounceCard onDark noMargin withPadding style={styles.card} onPress={onPress(fundInfo.fundInfo.title)}>
        {fundInfo.fundInfo.icon(colors.sectors[fundInfo.fundInfo.colorKey])}
        <Spacer h={16}/>
        <Text Text-16>{fundInfo.fundInfo.title}</Text>
        <Text TextThin-14 Secondary>
          {fundInfo.fundInfo.totalNumber} {formatPlural('fund', 'funds', fundInfo.fundInfo.totalNumber)}
        </Text>
      </TouchableBounceCard>
    </View>);
};
export default FundThemeCategorizationCard;
const styles = StyleSheet.create({
    cardWrapper: {
        flexGrow: 1,
        flexBasis: '40%',
    },
    card: {
        flex: 1,
    },
});
